import { Progress } from '@/components/ui/progress'
import { cn } from '@/lib/utils'
import type { ResourceUsage } from '@/types/database'

interface UsageBarProps {
  label: string
  usage: ResourceUsage
  className?: string
}

const levelColors: Record<string, string> = {
  ok: 'bg-muted-foreground/50',
  warning: 'bg-amber-500',
  critical: 'bg-orange-500',
  blocked: 'bg-red-500',
}

export function UsageBar({ label, usage, className }: UsageBarProps) {
  const isUnlimited = usage.limit === null

  return (
    <div className={cn('space-y-1.5', className)}>
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">{label}</span>
        <span className={cn(
          'font-medium tabular-nums',
          usage.level === 'blocked' && 'text-red-500',
          usage.level === 'critical' && 'text-orange-500',
          usage.level === 'warning' && 'text-amber-500',
        )}>
          {isUnlimited ? (
            <>{usage.current} / <span className="text-muted-foreground">unlimited</span></>
          ) : (
            `${usage.current} / ${usage.limit}`
          )}
        </span>
      </div>
      {!isUnlimited && (
        <Progress
          value={Math.min(usage.percentage ?? 0, 100)}
          className="h-1.5"
          indicatorClassName={levelColors[usage.level] || levelColors.ok}
        />
      )}
    </div>
  )
}
